// Adds Tailwind variables to the global scope
import "./setup/tailwind-setup.js";

// Setup LordIcon - <lord-icon> element
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
defineElement(lottie.loadAnimation);

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

import AOS from "aos";
AOS.init({ disable: "mobile" });

document.getElementById("hamburgerToggle").onclick = () => {
	document.getElementById("hamburger").classList.toggle("is-active"), document.getElementById("mobileMenu").classList.toggle("h-[2500px]");
};

var containerWidth = document.querySelector(".container").offsetWidth;
var viewWidth = window.innerWidth;
var marginCalc = (viewWidth - containerWidth) / 2;

document.querySelectorAll(".carousel-overflow").forEach((element) => {
	element.style.marginLeft = `${marginCalc}px`;

	if (window.innerWidth < 768) {
		element.style.marginRight = `${marginCalc}px`;
	}
});

// Show Q&A Answer

const questions = document.getElementsByClassName("question");
for (let i = 0; i < questions.length; i++) {
	questions[i].addEventListener("click", function () {
		this.classList.toggle("active-question");
	});
}

window.addEventListener("load", bgImageOffsetShards);
window.addEventListener("resize", bgImageOffsetShards);

function bgImageOffsetShards() {
	var offsetShard = document.getElementById("offsetShard");
	var content = document.getElementById("text-bg");
	var overflowShard = document.getElementById("overflowShard");

	var offsetMargin = Math.ceil(offsetShard.offsetWidth) - 1;
	offsetShard.style.marginLeft = "-" + offsetMargin + "px";
	overflowShard.style.width = window.innerWidth - content.offsetWidth - offsetMargin + "px";
}
